<template>
  <v-row>
    <v-col cols="12" sm="12" md="12" lg="12">
      <v-btn color="primary" dark @click="resetPassword">Reset password</v-btn>
    </v-col>
  </v-row>
</template>
<script>
import firebase from "firebase";
export default {
  methods: {
    resetPassword() {
      var auth = firebase.auth();
      var emailAddress = this.$store.getters.user.email;

      auth
        .sendPasswordResetEmail(emailAddress)
        .then(() => {
          this.showSuccess("");
        })
        .catch(function (error) {
          this.showError(error.message);
        });
    },
  },
};
</script>